export class Features {
    [key: string]: any
}
